import { cva } from "class-variance-authority";
import { cn } from "cn";
import type React from "react";
import Avatar from "@/components/ui/avatar/avatar";

const avatarOnlineVariants = cva(
  cn(
    /* sorted */
    "absolute bottom-0 end-0",
    "size-3",
    "rounded-full ring-2 ring-ring-light-max",
  ),
  {
    variants: {
      size: {
        xs: "size-1",
        sm: "size-1",
        base: "size-1",
        md: "size-2",
        lg: "size-2",
        xl: "size-3",
        "2xl": "size-4",
        "3xl": "size-4",
      },
      isOnline: {
        true: "bg-bg-success-max",
        false: "bg-bg-indigo-min-light",
      },
    },
    defaultVariants: {
      size: "base",
    },
  },
);

export const AvatarOnline = ({
  isOnline = false,
  size,
  ...props
}: React.ComponentProps<typeof Avatar> & {
  isOnline?: boolean;
}) => {
  return (
    <div className="shrink-0">
      <div className="flex relative">
        <Avatar size={size} {...props} />
        <span className={cn(avatarOnlineVariants({ size, isOnline }))}>
          <span className="sr-only">{isOnline ? "Online" : "Offline"}</span>
        </span>
      </div>
    </div>
  );
};
